export const Constants = {
  TAG_NAME: 'pop-maturity-and-duration-chart-component',
  MATURITY_LABEL: 'Maturity',
  DURATION_LABEL: 'Duration',
  PERCENT_OF_PORTFOLIO_LABEL: '% of portfolio',
  BENCHMARK_LABEL: '% of benchmark',
} as const;
